export default __webpack_public_path__ + "static/media/private.7969780d.svg";